<template>
	<step
		name="page-count"
		title="Aantal pagina's"
		valid>
		<template #title>
			<div class="grid">
				<div class="cell cell--fit">
					<h5
						v-if="shouldRowBeActive"
						class="configurator-step__title cursor-pointer"
						@click="setStepActive('page-count')">
						<span class="configurator-step__count configurator-step__count--valid"/>
						Aantal pagina's
						<span class="configurator-step__semi-colon configurator-step__not-active-mobile">:</span>
						<span class="configurator-step__item configurator-step__not-active-mobile">
							{{ pageCount }}
						</span>
					</h5>
					<h5 v-else class="configurator-step__title configurator-step--inactive">
						<span class="configurator-step__count">{{ getStepInt }}</span>
						Aantal pagina's
					</h5>
				</div>
			</div>
		</template>
		<div class="configurator-options">
			<page-count />
		</div>
	</step>
</template>
<script>
import step from "@/components/step/step";
import formatOption from "@/components/format/format-option";
import formatCustom from "@/components/optional/format-custom";
import pageCount from "@/components/optional/page-count";

export default {
	name: "PageStep",
	components: {
		step,
		formatOption,
		formatCustom,
		pageCount
	},
	computed: {
		pageCount () {
			return this.$store.getters.getPageCount;
		},
		isPageStep () {
			return this.$store.getters.getCurrentStep.data.name === "page-count";
		},
		shouldRowBeActive () {
			if (this.isPageStep) {
				return true;
			}

			// if the step after the page-step has options associated with it, make the row active.
			if (this.stepAfterPageStepHasValue) {
				return true;
			}

			// if the current step is right after the page-step, make the row active, regardless of step state
			if (this.getPreviousStepName === "page-count") {
				return true;
			}

			return false;
		},
		getAllSteps () {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep () {
			return this.$store.getters.getCurrentStep;
		},
		stepAfterPageStepHasValue () {
			const countStepInt = this.getAllSteps.findIndex(s => s.name === "page-count");
			const stepAfterCountStep = this.getStepByIndex(countStepInt + 1);
			return stepAfterCountStep ? stepAfterCountStep.valid : false;
		},
		getPreviousStepName () {
			const previousStep = this.getAllSteps[this.getCurrentStep.index - 1];
			return previousStep ? previousStep.name : null;
		},
		getStepInt () {
			const step = this.getAllSteps.find(s => s.name === "page-count");
			return this.getAllSteps.indexOf(step) + 1;
		}
	},
	methods: {
		stepExists (stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive (step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		},

		getStepByIndex (index) {
			return this.getAllSteps[index] || null;
		}
	}
};
</script>
<style>
.configurator-step--inactive {
	background: #f9fafb !important;
	color: #667085 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/optional/page-step.vue